import { Component, inject, Inject } from '@angular/core';
import { FormBuilder, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDatepickerModule } from '@angular/material/datepicker';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogContent,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatStepperModule } from '@angular/material/stepper';
import Swal from 'sweetalert2';
import { PacienteService } from '../../../core/services/pacientes.service';
import { IndicacionService } from '../../../core/services/indicacion.service';

@Component({
  selector: 'app-nueva-indicacion-dialog',
  imports: [
    MatStepperModule,
    MatIconModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatDatepickerModule,
    MatDialogActions,
    MatDialogContent,
  ],
  templateUrl: './nueva-indicacion-dialog.html',
  styleUrl: './nueva-indicacion-dialog.scss',
})
export class NuevaIndicacionDialog {
  constructor(
    private dialogRef: MatDialogRef<NuevaIndicacionDialog>,
    private indicacionService: IndicacionService,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {}

  private fb = inject(FormBuilder);

  form = this.fb.group({
    indicacion: [''],
    descripcion: [''],
  });

  ngOnInit(): void {
    // Si existe medicamento, significa que estamos EDITANDO
    if (this.data?.indicacion) {
      this.form.patchValue({
        indicacion: this.data.indicacion.titulo,
        descripcion: this.data.indicacion.descripcion,
      });
    }
  }

  cerrar() {
    this.dialogRef.close();
  }

  guardar(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    const valores = this.form.getRawValue();

    const payload = {
      titulo: valores.indicacion,
      descripcion: valores.descripcion,
    };

    // console.log('VALORES DEL FORMULARIO:', valores);
    // console.log('PAYLOAD ENVIADO:', payload);

    // ============================================
    // EDITAR INDICACIÓN
    // ============================================
    if (this.data?.indicacion?.id) {
      const id = this.data.indicacion.id;

      // console.log('EDITANDO INDICACIÓN:', id);

      this.indicacionService.actualizarIndicacion(id, payload).subscribe({
        next: (respuesta) => {
          Swal.fire({
            icon: 'success',
            title: 'Indicacion actualizada',
            text: 'La indicación fue actualizada correctamente.',
            showConfirmButton: false,
            timer: 2000,
          }).then(() => {
            // console.log('Respuesta del backend:', respuesta);

            this.dialogRef.close(respuesta?.data ?? respuesta);
          });
        },

        error: (error) => {
          // console.error('Error al actualizar la indicación:', error);

          Swal.fire({
            icon: 'error',
            title: 'No se pudo actualizar',
            text: error?.error?.message ?? 'Ocurrió un error al actualizar la indicación.',
            showConfirmButton: false,
            timer: 2000,
          });
        },
      });

      return;
    }

    // ============================================
    // CREAR INDICACIÓN
    // ============================================

    // console.log('CREANDO NUEVA INDICACIÓN');

    this.indicacionService.crearIndicacion(payload).subscribe({
      next: (respuesta) => {
        Swal.fire({
          icon: 'success',
          title: 'Registro exitoso',
          text: 'La nueva indicación fue agregada correctamente.',
          showConfirmButton: false,
          timer: 2000,
        }).then(() => {
          // console.log('Respuesta del backend:', respuesta);

          this.dialogRef.close(respuesta?.data ?? respuesta);
        });
      },

      error: (error) => {
        // console.error('Error al agregar la nueva indicación:', error);

        Swal.fire({
          icon: 'error',
          title: 'No se pudo agregar',
          text: error?.error?.message ?? 'Ocurrió un error al guardar la nueva indicación.',
          showConfirmButton: false,
          timer: 2000,
        });
      },
    });
  }
}
